import { render, staticRenderFns } from "./ZhiYaDetail.vue?vue&type=template&id=6c36daf6&scoped=true&"
import script from "./ZhiYaDetail.vue?vue&type=script&lang=js&"
export * from "./ZhiYaDetail.vue?vue&type=script&lang=js&"
import style0 from "./ZhiYaDetail.vue?vue&type=style&index=0&id=6c36daf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c36daf6",
  null
  
)

export default component.exports